/* eslint-disable jira/i18n/id-named-by-package */
import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	dndFocused: {
		id: 'native-issue-table.issue-table.table-header.dnd-focused',
		defaultMessage:
			'{column} can be moved. Make sure your screen reader isn’t in browse mode, press the spacebar to grab it and the arrow keys to move it.',
		description: 'Screen reader message when drag and drop column is focused',
	},
	dndPicked: {
		id: 'native-issue-table.issue-table.table-header.dnd-picked',
		defaultMessage:
			'{column} grabbed. Current position is {position} of {total}. Use the arrow keys to move, spacebar to drop, escape to cancel.',
		description: 'Screen reader message when drag and drop column is picked',
	},
	dndMoved: {
		id: 'native-issue-table.issue-table.table-header.dnd-moved',
		defaultMessage: 'You’ve moved {column} from {previousPosition} to {position} of {total}.',
		description: 'Screen reader message when drag and drop column is moved',
	},
	dndReturned: {
		id: 'native-issue-table.issue-table.table-header.dnd-returned',
		defaultMessage: 'You’ve moved {column} back to its original position {position} of {total}.',
		description: 'Screen reader message when drag and drop column is back',
	},
	dndDropped: {
		id: 'native-issue-table.issue-table.table-header.dnd-dropped',
		defaultMessage: 'You’ve dropped {column}. Final position is {position} of {total}.',
		description: 'Screen reader message when drag and drop column is dropped',
	},
});
